import { FieldPath } from '@/modules/dynamic-form/models/FieldPath.model';
import { toFieldPath } from '@/modules/dynamic-form/utils/to-field-path/toFieldPath';

export const AM_BEST_FINANCIAL_SIZE_CATEGORY_FIELD = toFieldPath('policy.carrier.amBestFinancialSizeCategory');
export const AM_BEST_FINANCIAL_STRENGTH_RATING_FIELD = toFieldPath('policy.carrier.amBestFinancialStrengthRating');

export const AM_BEST_FINANCIAL_FIELDS = [
    AM_BEST_FINANCIAL_STRENGTH_RATING_FIELD,
    AM_BEST_FINANCIAL_SIZE_CATEGORY_FIELD,
] as FieldPath[];

export const AM_BEST_FIELDS = [
    toFieldPath('policy.carrier.name'),
    toFieldPath('policy.carrier.naicNumber'),
    ...AM_BEST_FINANCIAL_FIELDS,
] as FieldPath[];

export const AM_BEST_FIELD_FIRST = AM_BEST_FIELDS[0];

export const AM_BEST_FINANCIAL_SIZE_CATEGORY_VALUES = [
    {
        label: 'I',
        value: 1,
    },
    {
        label: 'II',
        value: 2,
    },
    {
        label: 'III',
        value: 3,
    },
    {
        label: 'IV',
        value: 4,
    },
    {
        label: 'V',
        value: 5,
    },
    {
        label: 'VI',
        value: 6,
    },
    {
        label: 'VII',
        value: 7,
    },
    {
        label: 'VIII',
        value: 8,
    },
    {
        label: 'IX',
        value: 9,
    },
    {
        label: 'X',
        value: 10,
    },
    {
        label: 'XI',
        value: 11,
    },
    {
        label: 'XII',
        value: 12,
    },
    {
        label: 'XIII',
        value: 13,
    },
    {
        label: 'XIV',
        value: 14,
    },
    {
        label: 'XV',
        value: 15,
    },
];

export const AM_BEST_FINANCIAL_STRENGTH_RATING_VALUES = [
    {
        value: 'A++',
        label: 'A++',
    },
    {
        value: 'A+',
        label: 'A+',
    },
    {
        value: 'A',
        label: 'A',
    },
    {
        value: 'A-',
        label: 'A-',
    },
    {
        value: 'B++',
        label: 'B++',
    },
    {
        value: 'B+',
        label: 'B+',
    },
    {
        value: 'B',
        label: 'B',
    },
    {
        value: 'B-',
        label: 'B-',
    },
    {
        value: 'C++',
        label: 'C++',
    },
    {
        value: 'C+',
        label: 'C+',
    },
    {
        value: 'C',
        label: 'C',
    },
    {
        value: 'C-',
        label: 'C-',
    },
    {
        value: 'D',
        label: 'D',
    },
    {
        value: '-',
        label: '-',
    },
    {
        value: 'E',
        label: 'E',
    },
    {
        value: 'F',
        label: 'F',
    },
    {
        value: 'S',
        label: 'S',
    },
    {
        value: 'NR',
        label: 'NR',
    },
];

export const AmBestFetchStatus = {
    loading: 'loading',
    fetched: 'fetched',
    failed: 'failed',
    closed: 'closed',
};

export const AmBestAutoPropagationStatus = {
    fetchError: 'Auto-match not identified, please select value manually.',
    singleMatch: 'Auto-matched with result from the AM Best database.',
    itemSelected: 'Auto-matched with result from the AM Best database.',
    multipleMatches: 'Multiple auto-matches results available, select one.',
    zeroMatches: 'No AM Best match found. Please select value manually.',
    requiredFieldsEmpty: 'Auto-match not identified, Carrier Name and Naic Number are empty.',
};
